import { Component, Input } from '@angular/core';
import { ContractModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-contract-information',
    templateUrl: './contract-information.component.html',
    styleUrls: ['./contract-information.component.scss'],
    standalone: false,
})
export class ContractInformationComponent {
    @Input()
    public model: ContractModel;
}
